import { last } from 'lodash/fp';

import { InsuranceTypeValue } from '../../types';

const getInsuranceTypeFromLocation = (pathName: string) =>
  last(/^\/?(.*?)-insurance/i.exec(pathName)) as InsuranceTypeValue;

export default getInsuranceTypeFromLocation;
